enum STEPS {
    FILES_UPLOAD = 1,
    SIGNERS_REGISTER
}

export default STEPS;